import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./Debug/App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

// Function to hide the HTML loader smoothly
const hideHTMLLoader = () => {
  const loader = document.getElementById("startingLoader");
  if (loader) {
    // Check if HTML loading is complete
    if (window.loadingComplete) {
      // Smooth fade out
      loader.style.transition = "opacity 0.3s ease-out";
      loader.style.opacity = "0";

      // Completely hide after animation
      setTimeout(() => {
        loader.style.display = "none";
      }, 300);
    } else {
      // If HTML loading not complete, wait and try again
      setTimeout(hideHTMLLoader, 100);
    }
  }
};

// Render the React app
ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root"),
  () => {
    // This callback runs after React has finished rendering
    // Add a small delay to ensure DOM is fully updated
    setTimeout(() => {
      hideHTMLLoader();
    }, 50);
  }
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

serviceWorkerRegistration.unregister();
// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
